/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "context";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// ENV Values
const apiUrl = process.env.REACT_APP_API_URL;
export default function data(extended = true) {
  const { user } = useContext(UserContext);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${apiUrl}/user_events.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user.id,
            isAdmin: user.isAdmin ? user.isAdmin : false,
          }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setEvents(data.events);
      } catch (error) {
        console.error("There was an error fetching the events!", error);
      }
    };

    if (user.id) {
      fetchEvents();
    }
  }, [user]);

  // Define the base columns
  const columns = [
    {
      Header: "eventi",
      accessor: "event_name",
      sortType: "alphanumeric",
      align: "left",
      Cell: ({ row }) => (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          <Link to={`/app/event/${row.original.id}`}>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              ml={1}
              lineHeight={1}
              title={`${row.original.address_city} - ${row.original.event_name}`}
            >
              {`${row.original.address_city} - ${row.original.event_name}`.length > 25
                ? `${`${row.original.address_city} - ${row.original.event_name}`.slice(0, 22)}...`
                : `${row.original.address_city} - ${row.original.event_name}`}
            </MDTypography>
          </Link>
          {(row.original.invoice_confirm == 1 || row.original.invoice_confirm === "1") && (
            <MDBox 
              sx={{ 
                ml: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#4CAF50",
                borderRadius: "50%",
                width: 26,
                height: 26,
                padding: "4px"
              }}
            >
              <Icon sx={{ fontSize: 16, color: "#ffffff" }}>check</Icon>
            </MDBox>
          )}
        </MDBox>
      ),
    },
  ];
  if (user.isAdmin && extended) {
    columns.push({ Header: "nome", accessor: "name", align: "center", sortType: "alphanumeric" });
    columns.push({
      Header: "nome dell'azienda",
      accessor: "company_name",
      align: "center",
      sortType: "alphanumeric",
    });
  }
  columns.push({ Header: "progressi", accessor: "progress", align: "center" });
  columns.push({ Header: "stati del permesso", accessor: "status", align: "center" });
  // Conditionally add the "azione" column
  if (extended) {
    columns.push({ Header: " Data di inizio", accessor: "date", align: "center" });
  }

  return {
    columns,
    rows: events.map((event) => {
      // Format the start date
      const formattedDate = new Date(event.start_date);
      const startDate = `${String(formattedDate.getDate()).padStart(2, "0")}-${String(
        formattedDate.getMonth() + 1
      ).padStart(2, "0")}-${formattedDate.getFullYear()}`;

      return {
        id: event.id,
        event_name: event.event_name,
        address_city: event.address_city,
        invoice_confirm: event.invoice_confirm,
        ...(extended && {
          name: `${event.user_surname} ${event.user_name}`, // Store as a string for sorting
          company_name: event.company_name, // Store as a string for sorting
        }),
        progress: (
          <MDBox width="8rem">
            <MDProgress
              value={
                event.totalPermissions === "0"
                  ? 0
                  : Math.floor((100 * event.closedPermissions) / event.totalPermissions)
              }
              color={
                event.closedPermissions === event.totalPermissions && event.totalPermissions > 0
                  ? "success"
                  : "secondary"
              }
              variant="gradient"
              label={true}
              sx={{
                width: "100%",
                mt: "auto",
              }}
            />
          </MDBox>
        ),
        status: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {event.status}
          </MDTypography>
        ),
        ...(extended && {
          date: startDate, // Use the formatted date in dd-mm-yyyy format
        }),
      };
    }),
  };
}

